import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import "./App.css";
import Sidebar from "./comp/Sidebar";
import Home from "./pages/Home";
import SingleProject from "./pages/SingleProject"; // Import the new page
import { TbMoonStars } from "react-icons/tb";
import { FiSun } from "react-icons/fi";
import { RxCross2 } from "react-icons/rx";
import { FiMenu } from "react-icons/fi";
import { useState } from "react";

function App() {
  const [darkMode, setDarkMode] = useState(false);
  const [menuBar, setMenuBar] = useState(true);

  return (
    <Router>
      <div className={darkMode ? "darkmode app" : "app"}>
        {menuBar ? (
          <FiMenu onClick={() => setMenuBar(false)} className="menuIcon" />
        ) : (
          <RxCross2 onClick={() => setMenuBar(true)} className="menuIcon" />
        )}

        {!darkMode ? (
          <TbMoonStars onClick={() => setDarkMode(true)} className="mainIcon" />
        ) : (
          <FiSun onClick={() => setDarkMode(false)} className="mainIcon" />
        )}

        <Sidebar menuBar={menuBar} setMenuBar={setMenuBar} />

        <Routes>
          <Route path="/" element={<Home />} /> {/* Home Page */}
          <Route path="/project/:id" element={<SingleProject />} /> {/* Single Project Page */}
        </Routes>
      </div>
    </Router>
  );
}

export default App;
